import { type JoinedWorkspaceRelation } from '../../contracts';
import { useQueryWorkspaces } from './useQueryWorkspaces';
import { useWorkspaceId } from './useWorkspaceId';

/**
 * The workspace that matches the persisted {@link workspaceIdAtom} exactly.
 *
 * Returns `null` while loading, when the list is empty, or when the atom is
 * null/stale — so consumers never treat a fallback workspace as the one
 * requests are scoped to. {@link useHydrateWorkspaceId} owns writing the atom
 * (and its default/stale fallbacks); this hook only reads.
 *
 * The workspace switcher keeps its own display fallback while the atom
 * hydrates — do not add that logic here.
 *
 * Extracted to @heidi/workspace/data — history:
 * `git log --follow src/features/workspace/hooks/useCurrentWorkspace.ts`.
 */
export function useCurrentWorkspace(): JoinedWorkspaceRelation | null {
  const { data } = useQueryWorkspaces();
  const workspaceId = useWorkspaceId();

  return (
    data?.workspaces.find((workspace) => workspace.workspace_id === workspaceId) ?? null
  );
}
